/**
 * Select Map
 *
 * マップ選択
 *
 * @param {string} target マップのセレクタ
 */

export function selectMap(target) {
	const maps = document.querySelectorAll(target + "__map");
	const areas = document.querySelectorAll(target + "__map [data-area]");
	const lists = document.querySelectorAll(target + "__list");
	let originalArea = maps[0]?.dataset.currentArea || "3"; // 最初のマップの値を取得

	// すべてのマップの data-current-area を更新する関数
	function updateAllMaps(area) {
		maps.forEach((map) => {
			map.dataset.currentArea = area;
		});
		lists.forEach((list) => {
			list.dataset.currentArea = area;
		});
	}

	areas.forEach((area) => {
		// マウスオーバー時
		area.addEventListener("mouseover", function () {
			// マウスオーバーしたエリアの data-area を変更
			maps.forEach((map) => {
				map.dataset.currentArea = this.dataset.area;
			});
		});

		// マウスアウト時
		area.addEventListener("mouseout", function () {
			// すべてのエリアを元に戻す
			updateAllMaps(originalArea);
		});

		// クリック時
		area.addEventListener("click", function () {
			// クリックしたエリアの data-area を取得し、すべてのマップの data-current-area を更新
			originalArea = this.dataset.area;
			updateAllMaps(originalArea);
		});
	});
}
